module.exports = __webpack_public_path__ + "img/external-link.3f0bde87.svg";